import React, { useEffect, useState, useContext } from "react";
import ApiService from '../../functions/apiService';
import { Box, Chip, Table, TableBody, TableCell, InputAdornment, TableContainer, IconButton, TableHead, TableRow, Autocomplete, Typography, TextField, CircularProgress } from '@mui/material';
import Paper from '@mui/material/Paper';
import { Button, Col, Row } from "react-bootstrap";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import Modal from 'react-bootstrap/Modal';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import moment from "moment";
import { toast } from "react-toastify";
import { varFormatTime } from "../../utils/helperFunctions";
import AuthContext from "../../context/AuthContext";
import SearchIcon from "@mui/icons-material/Search";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import dayjs from 'dayjs';

export default function WeeklyVolunteerPositionAssign(props) {
    const { user, permission, v3Data } = useContext(AuthContext);
    const { isNightShift, mode2, onExpandChange, open, date, shift, allowedVars } = props
    const [empList, setEmpList] = useState([])
    const [posList, setPosList] = useState([])
    const [assignModal, setAssignModal] = useState(false);
    const [posId, setPosId] = useState('')
    const timeFormat = (timeStr) => timeStr?.slice(0, 5);
    const [search, setSearch] = useState('')
    const [deleteModal, setDeleteModal] = useState(false)
    const [isFirstTime, setIsFirsttime] = useState(true);
    const [shiftCode, setShiftCode] = useState('')
    const [posCode, setPosCode] = useState('')
    const [unassignEmp, setUnassignEmp] = useState('')
    const [customModal, setCustomModal] = useState(false)
    const [key, setKey] = useState(1)
    const [key2, setKey2] = useState(1)
    const [startTime, setStartTime] = useState('')
    const [endTime, setEndTime] = useState('')
    const [assignEmp, setAssignEmp] = useState('')
    const [posList2, setPosList2] = useState([]);
    const [modalShiftName, setModalShiftName] = useState();
    const [loading, setLoading] = useState(false);
    const [unassignPosition, setUnassignPosition] = useState('');
    const [confirmModal, setConfirmModal] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const [actionType, setActionType] = useState("");
    const [assignModalUser, setAssignModalUser] = useState(false);
    const [customModalUser, setCustomModalUser] = useState(false);
    const [deleteModalUser, setDeleteModalUser] = useState(false)
    const [posUserDate, setPosUserDate] = useState('')
    const [posUserShiftCode, setPosUserShiftCode] = useState('')
    const [posUserStartTime, setPosUserStartTime] = useState('')
    const [posUserEndTime, setPosUserEndTime] = useState('')
    const [unAssignReason, setUnAssignReason] = useState('')
    const [requestShiftUser, setRequestShiftUser] = useState(false);
    const [revertShiftReq, setRevertShiftReq] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);

    const modalClose = () => { setAssignModal(false), setEmpList(''), setSearch('') };
    const modalShow = () => setAssignModal(true);

    const getShiftSlots = (positionFilled, startTime, endTime) => {
        const parseTime = (time) => {
            const [h, m, s] = time.split(':').map(Number);
            return h * 60 + m + s / 60;
        };

        const formatMinutes = (mins) => {
            let h = Math.floor(mins / 60) % 24;
            let m = Math.floor(mins % 60);
            return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:00`;
        };

        let startMin = parseTime(startTime);
        let endMin = parseTime(endTime);

        const isOvernight = endMin <= startMin;
        if (isOvernight) endMin += 24 * 60;

        const normalizeTime = (t) => {
            let val = parseTime(t);
            if (isOvernight && val < startMin) val += 24 * 60;
            return val;
        };

        const sorted = [...(positionFilled || [])].sort(
            (a, b) => normalizeTime(a.Start_Time) - normalizeTime(b.Start_Time)
        );

        const slots = [];
        let currentStart = startMin;

        sorted.forEach((emp) => {
            let empStart = normalizeTime(emp.Start_Time);
            let empEnd = normalizeTime(emp.End_Time);

            if (empEnd <= empStart) empEnd += 24 * 60;

            if (empStart > currentStart) {
                slots.push({ type: 'open', start: currentStart, end: empStart });
            }

            slots.push({
                type: 'filled',
                ...emp,
                start: empStart,
                end: empEnd,
            });

            currentStart = empEnd;
        });

        if (currentStart < endMin) {
            slots.push({ type: 'open', start: currentStart, end: endMin });
        }

        return { slots, formatMinutes };
    };

    const columns = (shiftCode, shift, startTime, endTime) => {
        let col = [
            {
                field: 'Position_Name',
                headerName: 'Name',
                flex: 1,
                maxWidth: 200,
                minWidth: 160,
                renderCell: (params) => {
                    return (
                        <Box>
                            {params.value}
                        </Box>
                    );
                }
            },
            ...(v3Data?.V3_OPENPOSITION_VOULTEER_DEPARTMENT && v3Data?.V3_OPENPOSITION_VOULTEER_DEPARTMENT == 'true') ?
                [
                    {
                        field: 'title',
                        headerName: 'Name',
                        flex: 1,
                        minWidth: 230,
                        maxWidth: 400,
                        renderCell: (params) => {
                            const { slots, formatMinutes } = getShiftSlots(
                                params.row.Position_Filled,
                                startTime,
                                endTime
                            );

                            return (
                                <>
                                    {slots.map((slot, index) => (
                                        <div
                                            key={index}
                                            className={
                                                (params?.row?.Position_Filled.length > 0 && slot.type === 'open') ||
                                                    (slot.type === 'filled' && params?.row?.Position_Filled.length > 1)
                                                    ? 'shift-arr'
                                                    : ''
                                            }
                                            style={{ width: '100%', padding: '6px 0px' }}
                                        >
                                            <Row style={{ alignItems: 'center', marginTop: '5px' }} className="g-0">
                                                {slot.type === 'filled' ? (
                                                    <>
                                                        <Col md={8} className="p-0" style={{ whiteSpace: 'normal', color: 'green', fontSize: '13px', fontWeight: '550' }}>
                                                            {slot.Employee_Rank} {slot.Employee_Name} (
                                                            {varFormatTime(timeFormat(formatMinutes(slot.start)), user?.Time_Format)} -{' '}
                                                            {varFormatTime(timeFormat(formatMinutes(slot.end)), user?.Time_Format)})
                                                            {/* <span style={{
                                                                backgroundColor: 'green', borderRadius: 50, color: '#fff', fontWeight: 'bold',
                                                                fontSize: 11, marginLeft: 5, width: 20, height: 20, display: 'inline-flex',
                                                                alignItems: 'center', justifyContent: 'center'
                                                            }}>
                                                                F
                                                            </span> */}
                                                        </Col>
                                                        <Col md={2} className="p-0">
                                                            {permission.includes('Emp_Auth') && (
                                                                <img
                                                                    src="/images/revert.png"
                                                                    onClick={() => {
                                                                        setDeleteModal(true);
                                                                        setUnassignPosition(params?.row)
                                                                        setUnassignEmp(slot);
                                                                    }}
                                                                    width={20}
                                                                    height={20}
                                                                    style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                                />
                                                            )}
                                                        </Col>
                                                    </>
                                                ) : (
                                                    <Col md={10} className="p-0" style={{ textAlign: 'left', color: 'red', fontSize: '13px' }}>
                                                        Open Position (
                                                        {varFormatTime(timeFormat(formatMinutes(slot.start)), user?.Time_Format)} -{' '}
                                                        {varFormatTime(timeFormat(formatMinutes(slot.end)), user?.Time_Format)})
                                                    </Col>
                                                )}
                                            </Row>
                                        </div>
                                    ))}
                                </>
                            );
                        },
                    },
                ]
                :
                [
                    {
                        field: 'title',
                        headerName: 'Name',
                        flex: 1,
                        minWidth: 230,
                        maxWidth: 400,
                        renderCell: (params) => (
                            <div className={params?.row?.Position_Filled.length > 1 && "shift-arr"} style={{ width: '100%' }}>
                                {params.row.Position_Filled.length > 0
                                    ? params.row.Position_Filled.map((emp, index) => (
                                        <Row style={{ alignItems: 'center', marginTop: '5px' }} className="g-0">
                                            <Col md={8} className="p-0" style={{ whiteSpace: 'normal' }}>
                                                {emp.Employee_Rank} {emp.Employee_Name + ' '}
                                                ({varFormatTime(timeFormat(emp?.Start_Time), user?.Time_Format)} - {varFormatTime(timeFormat(emp?.End_Time), user?.Time_Format)})
                                            </Col>
                                            <Col md={2} className="p-0">
                                                {(permission.includes('Emp_Auth')) &&
                                                    !Object.keys(allowedVars).includes('V3_VOLUNTEER_MEMBERS_SELF_ASSIGN') &&
                                                    <img
                                                        src="/images/revert.png"
                                                        onClick={() => {
                                                            setDeleteModal(true)
                                                            setUnassignEmp(emp)
                                                            setUnassignPosition(params?.row)
                                                        }}
                                                        width={20}
                                                        height={20}
                                                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                    />}

                                                {(permission.includes('Emp_Auth')) &&
                                                    JSON.parse(localStorage.getItem('user'))?.Emp_Code != emp?.Employee_ID &&
                                                    Object.keys(allowedVars).includes('V3_VOLUNTEER_MEMBERS_SELF_ASSIGN') &&
                                                    <img
                                                        src="/images/revert.png"
                                                        onClick={() => {
                                                            setDeleteModal(true)
                                                            setUnassignEmp(emp)
                                                            setUnassignPosition(params?.row)
                                                        }}
                                                        width={20}
                                                        height={20}
                                                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                    />}

                                                {Object.keys(allowedVars).includes('V3_VOLUNTEER_MEMBERS_SELF_ASSIGN') &&
                                                    emp.Allow_Self_Unassign === true && (
                                                        <img
                                                            src="/images/revert.png"
                                                            onClick={() => {
                                                                setDeleteModalUser(true);
                                                                setUnassignEmp(emp)
                                                                setUnassignPosition(params?.row)
                                                            }}
                                                            width={20}
                                                            height={20}
                                                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                        />
                                                    )}
                                            </Col>
                                        </Row>
                                    ))
                                    :
                                    <div style={{ textAlign: 'left' }}>Open Position</div>
                                }
                            </div>
                        )
                    },
                ],
            {
                field: 'action',
                headerName: 'Action',
                flex: 1,
                minWidth: 140,
                renderCell: (params) => {
                    const requestShiftAllowed =
                        allowedVars &&
                        Object.keys(allowedVars).includes('V3_VOLUNTEER_REQUEST_SHIFT');

                    const disabled = params?.row?.Has_Requested === true;

                    const reqAllowed = params?.row?.Position_Filled.length <= 0;

                    if (!permission.includes('Emp_Auth') && reqAllowed && requestShiftAllowed) {
                        return (
                            <div className="d-flex justify-content-start" style={{ alignItems: 'center' }}>
                                <ButtonTheme style={{ backgroundColor: disabled ? '#D0D5DD' : '#BF1D2D', borderRadius: '10px', gap: '3px', padding: '4px', fontSize: '13px' }}
                                    disabled={disabled}
                                    onClick={() => {
                                        setPosId(params?.row?.Position_Assignment_Id);
                                        setPosCode(params?.row?.Position_Code);
                                        getPositionName(
                                            shiftCode,
                                            params?.row?.Position_Assignment_Id
                                        );
                                        setRequestShiftUser(true)
                                    }}>
                                    <img
                                        src="/images/assign.png"
                                        style={{ height: '16px' }}>
                                    </img>
                                    Request Shift
                                </ButtonTheme>

                                {!permission.includes('Emp_Auth') && disabled && requestShiftAllowed &&
                                    <img
                                        src="/images/revert.png"
                                        onClick={() => {
                                            setPosId(params?.row?.Position_Assignment_Id);
                                            getPositionName(
                                                shiftCode,
                                                params?.row?.Position_Assignment_Id
                                            );
                                            setRevertShiftReq(true);
                                        }}
                                        width={20}
                                        height={20}
                                        style={{ cursor: 'pointer', marginLeft: '8px' }}
                                    />}
                            </div>
                        )
                    }

                    const availableCount = params.row.Available_Employee_Count;
                    const { slots } = getShiftSlots(
                        params.row.Position_Filled,
                        startTime,
                        endTime
                    );

                    const hasOpenSlot = slots.some(slot => slot.type === 'open');

                    const volunteerAllowed =
                        allowedVars &&
                        Object.keys(allowedVars).includes('V3_VOLUNTEER_MEMBERS_SELF_ASSIGN');

                    if (permission.includes('Emp_Auth') && hasOpenSlot && volunteerAllowed) {
                        return (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", gap: '10px' }}>

                                <ButtonTheme className='px-2 mt-1' style={{ backgroundColor: availableCount === 0 ? '#BF1D2D' : '#079E46', borderRadius: '10px', gap: '3px', padding: '4px' }}
                                    onClick={() => {
                                        setPosId(params?.row?.Position_Assignment_Id);
                                        setShiftCode(shiftCode);
                                        setPosCode(params?.row?.Position_Code);
                                        setModalShiftName(shift);
                                        getEmployeeList(
                                            shiftCode,
                                            params?.row?.Position_Code,
                                            params?.row?.Position_Assignment_Id,
                                            params?.row?.Shift_Date
                                        );
                                        modalShow();
                                    }}>
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "-7px",
                                            right: "-8px",
                                            background: 'white',
                                            color: availableCount === 0 ? "#ea4a5a" : "#22C55E",
                                            border: availableCount === 0 ? "2px solid #ea4a5a" : "2px solid #22C55E",
                                            borderRadius: "50%",
                                            width: "18px",
                                            height: "18px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "13px",
                                            fontWeight: 700
                                        }}
                                    >
                                        {availableCount}
                                    </span>
                                    <img
                                        src="/images/assign-1.png"
                                        style={{ height: '15px' }}>
                                    </img>
                                    Assign
                                </ButtonTheme>

                                {JSON.parse(localStorage.getItem('user'))?.Functional_Department != "FH247" &&
                                    <ButtonTheme className='px-2 mt-1' style={{ backgroundColor: '#BF1D2D', borderRadius: '10px', gap: '3px', padding: '4px' }}
                                        onClick={() => {
                                            setPosId(params?.row?.Position_Assignment_Id);
                                            setPosCode(params?.row?.Position_Code);
                                            getPositionName(
                                                shiftCode,
                                                params?.row?.Position_Assignment_Id
                                            );
                                            setAssignModalUser(true)
                                        }}>
                                        <img
                                            src="/images/assign.png"
                                            style={{ height: '16px' }}>
                                        </img>
                                        To Me
                                    </ButtonTheme>
                                }
                            </div>
                        )
                    }

                    if (permission.includes('Emp_Auth') && hasOpenSlot) {
                        return (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", gap: '10px' }}>

                                <ButtonTheme style={{ backgroundColor: availableCount === 0 ? '#BF1D2D' : '#079E46', borderRadius: '10px', gap: '3px', padding: '4px' }}
                                    onClick={() => {
                                        setPosId(params?.row?.Position_Assignment_Id);
                                        setShiftCode(shiftCode);
                                        setPosCode(params?.row?.Position_Code);
                                        setModalShiftName(shift);
                                        getEmployeeList(
                                            shiftCode,
                                            params?.row?.Position_Code,
                                            params?.row?.Position_Assignment_Id,
                                            params?.row?.Shift_Date
                                        );
                                        modalShow();
                                    }}>
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "-7px",
                                            right: "-8px",
                                            background: 'white',
                                            color: availableCount === 0 ? "#ea4a5a" : "#22C55E",
                                            border: availableCount === 0 ? "2px solid #ea4a5a" : "2px solid #22C55E",
                                            borderRadius: "50%",
                                            width: "18px",
                                            height: "18px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "12px",
                                            fontWeight: 600
                                        }}
                                    >
                                        {availableCount}
                                    </span>
                                    <img
                                        src="/images/assign-1.png"
                                        style={{ height: '15px' }}>
                                    </img>
                                    Assign
                                </ButtonTheme>
                            </div>
                        );
                    }

                    if (volunteerAllowed && hasOpenSlot) {
                        return (
                            <div className="w-100 d-flex justify-content-start">
                                <ButtonTheme style={{ backgroundColor: '#BF1D2D', borderRadius: '10px', gap: '3px', padding: '4px' }}
                                    onClick={() => {
                                        setPosId(params?.row?.Position_Assignment_Id);
                                        setPosCode(params?.row?.Position_Code);
                                        getPositionName(
                                            shiftCode,
                                            params?.row?.Position_Assignment_Id
                                        );
                                        setAssignModalUser(true)
                                    }}>
                                    <img
                                        src="/images/assign.png"
                                        style={{ height: '16px' }}>
                                    </img>
                                    To Me
                                </ButtonTheme>
                            </div>
                        );
                    }
                    return '';
                },
            }
        ]
        return col
    }

    const getPositionList = () => {
        setPageLoading(true);

        const body = {
            Shift_Date: date ? date : moment().format('YYYY-MM-DD')
        };

        ApiService.post('/volunteer-list-position-weekly', body)
            .then((res) => {
                const weeklyData = res?.result || [];

                const formatted = weeklyData.map((day) => {
                    let shiftsForDay = [];

                    shift.forEach((a) => {
                        day.data.forEach((b) => {
                            const shiftKey = String(
                                a.Shift ?? a.value ?? a.Shift_Code
                            );

                            let shiftCode = a.Shift_Code; // default

                            if (b?.Positions?.[a?.Shift] !== undefined) {
                                shiftCode = a.ShiftCode;
                            }

                            if (b.Positions?.[shiftKey]) {
                                shiftsForDay.push({
                                    data: b.Positions[shiftKey],
                                    shift: shiftKey,
                                    posName: b.Assignment_Name,
                                    shiftCode: shiftCode,
                                    startTime: a.Start_Time,
                                    endTime: a.End_Time
                                });
                            }
                        });
                    });

                    const order = {
                        'Primary Coverage': 1,
                        'Second Crew': 2,
                        'Third Crew': 3
                    };

                    shiftsForDay.sort(
                        (a, b) => (order[a.posName] || 99) - (order[b.posName] || 99)
                    );

                    return {
                        date: day.date,
                        dateFormatted: day.date_formatted,
                        shifts: shiftsForDay
                    };
                });

                setPosList2(formatted);
                setPageLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setPageLoading(false);
            });
    };


    const unAssignPosition = () => {
        const body = {
            "Shift_Date": date ? date : moment().format('YYYY-MM-DD'),
            "Shift_Code": unassignEmp?.Shift_Code,
            "Start_Time": unassignEmp?.Start_Time,
            "End_Time": unassignEmp?.End_Time,
            "Emp_Code": unassignEmp?.Employee_ID,
            "Position_Assignment_Id": unassignPosition?.Position_Assignment_Id,
            "Unassign_Note": unAssignReason
        }
        ApiService.post('/volunteer-unassign-position', body)
            .then((data) => {
                getPositionList()
                toast.success(data?.message)
                setDeleteModal(false)
                setUnAssignReason('')
            })
            .catch((err) => {
                toast.error(err?.data?.message)
                setDeleteModal(false)
            })
    }

    const getEmployeeList = (shift_code, pos_code, pos_id, shift_date_emp) => {
        setLoading(true);
        let tempShiftCode = shift_code ? shift_code : shiftCode
        let tempPosCode = pos_code ? pos_code : posCode
        let tempPosId = pos_id ? pos_id : posId
        const body = {
            "Shift_Date": shift_date_emp,
            "Shift_Code": tempShiftCode,
            "Position_Code": tempPosCode,
            "Position_Assignment_Id": tempPosId,
            "search": search
        }
        ApiService.post('/volunteer-hitlist-employees', body)
            .then((data) => {
                setEmpList(data?.employees)
                setLoading(false);
            })
            .catch(() => {
                console.error('error')
                setLoading(false);
            })
    }

    const assignPosition = (row, type = 'fulltime') => {
        var body = {}
        if (type == 'custom') {
            if (startTime == '' || endTime == '') {
                toast.error('Please fill start time and end time')
                return
            }
            body = {
                "Shift_Date": assignEmp?.Shift_Date,
                "Shift_Code": assignEmp?.Shift_Code,
                "Start_Time": startTime,
                "End_Time": endTime,
                "Emp_Code": assignEmp?.Emp_Code,
                "Position_Assignment_Id": posId,
                "isFullTime": false,
                "Force_Assign": !(row?.Has_Volunteer_Signup),
            }
        }
        else {
            body = {
                "Shift_Date": row?.Shift_Date,
                "Shift_Code": row?.Shift_Code,
                "Start_Time": row?.Start_Time,
                "End_Time": row?.End_Time,
                "Emp_Code": row?.Emp_Code,
                "Position_Assignment_Id": posId,
                "isFullTime": row?.Value == 'FULLTIME' ? true : false,
                "Force_Assign": !(row?.Has_Volunteer_Signup),
            }
        }
        ApiService.post('/volunteer-assign-position', body)
            .then((data) => {
                toast.success(data?.message)
                modalClose()
                setCustomModal(false)
                setStartTime('')
                setEndTime('')
                getPositionList()
            })
            .catch((err) => {
                toast.error(err?.data?.message)
            })
    }

    const assignUserPosition = (fullTime) => {
        const body = {
            "Shift_Date": posUserDate,
            "Shift_Code": posUserShiftCode,
            "Start_Time": startTime ? startTime : posUserStartTime,
            "End_Time": endTime ? endTime : posUserEndTime,
            "Position_Assignment_Id": posId,
            "isFullTime": fullTime
        }
        ApiService.post('/employee-assign-volunteer-position', body)
            .then((data) => {
                setCustomModalUser(false)
                setAssignModalUser(false)
                toast.success(data?.message)
                setStartTime('')
                setEndTime('')
                setPosUserDate('')
                setPosUserShiftCode('')
                setPosUserStartTime('')
                setPosUserEndTime('')
                getPositionList()
            })
            .catch((err) => {
                toast.error(err?.data?.message)
            })
    }

    const unAssignUserPosition = () => {
        const body = {
            "Shift_Date": date ? date : moment().format('YYYY-MM-DD'),
            "Shift_Code": unassignEmp?.Shift_Code,
            "Start_Time": unassignEmp?.Start_Time,
            "End_Time": unassignEmp?.End_Time,
            "Position_Assignment_Id": unassignPosition?.Position_Assignment_Id
        }
        ApiService.post('/employee-unassign-volunteer-position', body)
            .then((data) => {
                getPositionList()
                toast.success(data?.message)
                setDeleteModalUser(false)
            })
            .catch((err) => {
                toast.error(err?.data?.message)
                setDeleteModalUser(false)
            })
    }

    const revertReqAssign = () => {
        const body = {
            "Shift_Date": posUserDate,
            "Shift_Code": posUserShiftCode,
            "Position_Assignment_Id": posId
        }
        ApiService.post('/revert-request-assignment', body)
            .then((data) => {
                toast.success(data?.message)
                setPosUserDate('')
                setPosUserShiftCode('')
                setRevertShiftReq(false)
                getPositionList()
            })
            .catch((err) => {
                toast.error(err?.data?.message)
                setDeleteModalUser(false)
            })
    }

    const requestShift = () => {
        const body = {
            "Shift_Date": posUserDate,
            "Shift_Code": posUserShiftCode,
            "Position_Assignment_Id": posId,
        }
        ApiService.post('/requestAssignmentShift', body)
            .then((data) => {
                toast.success(data?.message)
                setPosUserDate('')
                setPosUserShiftCode('')
                setRequestShiftUser(false)
                getPositionList()
            })
            .catch((err) => {
                toast.error(err?.data?.message)
            })
    }

    const getPositionName = (shift_code, pos_id) => {
        setLoading(true);
        let tempShiftCode = shift_code ? shift_code : shiftCode
        let tempPosId = pos_id ? pos_id : posId
        const body = {
            "Shift_Date": date ? date : moment().format('YYYY-MM-DD'),
            "Shift_Code": tempShiftCode,
            "Position_Assignment_Id": tempPosId,
        }
        ApiService.post('/employee-volunteer-position-detail', body)
            .then((data) => {
                setPosUserDate(data?.shift_date)
                setPosUserShiftCode(data?.shift_detail?.Shift_Code)
                setPosUserStartTime(data?.shift_detail?.Start_Time)
                setPosUserEndTime(data?.shift_detail?.End_Time)
                setLoading(false);
            })
            .catch(() => {
                console.error('error')
                setLoading(false);
            })
    }

    const selectShift = (type, time) => {
        if (type == 'start_time') {
            setStartTime(moment(time).format('HH:mm:ss'))
        }
        else {
            setEndTime(moment(time).format('HH:mm:ss'))
        }
    }

    useEffect(() => {
        setIsFirsttime(false)
        // getShiftList()
    }, [])

    useEffect(() => {
        if (shift && shift.length > 0) {
            getPositionList()
        }
    }, [shift, mode2])

    useEffect(() => {
        if (!isFirstTime && (search.length >= 3 || search == '')) {
            setTimeout(() => {
                getEmployeeList();
            }, 500);
        }
    }, [search])

    return (
        <>
            {pageLoading ? (
                <div
                    className="d-flex flex-column align-items-center justify-content-center"
                    style={{ height: 595 }}
                >
                    <img
                        src="/images/blur-logo.png"
                        style={{ height: 200, width: 250 }}
                        alt="Loading"
                    />
                    <span className="mt-4" style={{ color: '#555555' }}>
                        Loading...
                    </span>
                </div>
            ) :
                (<Row className="w-100 g-1">
                    <Row className="w-100 g-1">
                        {posList2?.map((day, dayIndex) => (
                            <Col md={12} key={dayIndex}>

                                {/* DATE HEADER */}
                                <div
                                    style={{
                                        marginTop: '20px',
                                        paddingLeft: '8px',
                                        fontSize: '18px',
                                        fontWeight: 700
                                    }}
                                >
                                    📅 {day.dateFormatted}
                                </div>

                                {/* COLLAPSES FOR THAT DATE */}
                                <Row className="g-1">
                                    {day.shifts.map((result, index) => (
                                        <Col md={6} key={index}>
                                            <CollapseComponent
                                                rows={result.data}
                                                name={
                                                    result.posName +
                                                    (
                                                        ['1', '2', '3', '4', '5'].includes(result.shift)
                                                            ? `(Shift-${result.shift})`
                                                            : `(${result.shift})`
                                                    )
                                                }
                                                columns={columns(
                                                    result.shiftCode,
                                                    result.shift,
                                                    result.startTime,
                                                    result.endTime
                                                )}
                                                checkboxSelection={false}
                                                open={open}
                                                onExpandChange={onExpandChange}
                                                showHeader={false}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        ))}
                    </Row>
                </Row>
                )}

            <Modal size="lg" show={assignModal} onHide={modalClose}>
                <Modal.Body className='p-4'>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography id="modal-modal-title" sx={{ fontSize: '21px', fontWeight: '700' }}>
                            Available Personnel For Shift - {modalShiftName}
                        </Typography>
                        <img src="/images/close-icon.svg" style={{ cursor: 'pointer' }} onClick={modalClose} />
                    </div>

                    <Box id="modal-modal-description" sx={{ mt: 2 }}>
                        <TextField
                            variant="outlined"
                            placeholder="Search by Name"
                            className="mt-0 w-100"
                            color='secondary'
                            onChange={(e) => setSearch(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton>
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                sx: {
                                    height: '48px',
                                    fontSize: '14px'
                                },
                            }}
                        />

                        {loading &&
                            <div className='my-5' style={{ display: 'flex', justifyContent: 'center' }}>
                                <CircularProgress />
                            </div>
                        }


                        {!loading && empList?.length === 0 ? (
                            <>
                                <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 'auto', marginTop: '10px' }}>
                                    <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                                    <span className='mt-4' style={{ color: '#555555' }}>
                                        No results found
                                    </span>
                                </div>
                            </>
                        ) : (<>
                            {!loading &&
                                <div style={{ maxHeight: '60vh', overflowX: 'auto', scrollbarWidth: 'none' }}>
                                    <TableContainer component={Paper} sx={{
                                        boxShadow: 'none !important',
                                        border: '1px solid #EAECF0',
                                        mt: 2,
                                        //   minWidth: allowedVars?.V3_SHOW_WEEKLY_OVERTIME_HOUR ? '60vw' : 'auto'
                                    }}>

                                        <Table aria-label="customized table">
                                            <TableHead sx={{ backgroundColor: "#E5E9EB" }} >
                                                <TableRow>
                                                    <TableCell sx={{ minWidth: 130 }}>Name</TableCell>
                                                    <TableCell sx={{ minWidth: 90 }} >Availability</TableCell>
                                                    <TableCell sx={{ minWidth: 50 }} >Hours</TableCell>
                                                    {allowedVars?.V3_SHOW_WEEKLY_OVERTIME_HOUR && (
                                                        <TableCell sx={{ minWidth: 40 }} >Weekly Hour</TableCell>
                                                    )}
                                                    <TableCell sx={{ minWidth: 130 }}>Timestamp</TableCell>
                                                    <TableCell sx={{ minWidth: 200 }}>Action</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {empList.length > 0 ? empList.map((row) => (

                                                    <TableRow key={row?.fullName} sx={{
                                                        height: '22px',
                                                        '& .MuiTableCell-root': {
                                                            border: 'none',
                                                            color: row?.Has_Volunteer_Signup === false ? 'red !important' : 'inherit'
                                                        },
                                                        '&:nth-of-type(even)': {
                                                            backgroundColor: 'rgba(204, 204, 204, 0.2)',
                                                        },
                                                    }}>

                                                        <TableCell component="th" scope="row">
                                                            {row?.fullName}
                                                        </TableCell>

                                                        <TableCell component="th" scope="row">
                                                            {/* {moment(row?.Shift_Date).format('dddd')}  */}
                                                            {/* {row?.Value != 'FULLTIME' ? 'on ' + row?.Value.replace(/(^\s*,)|(,\s*$)/g, '') : ''} */}
                                                            {row?.Has_Volunteer_Signup === false ? '-' : (row?.Value == 'FULLTIME' ? 'Fulltime' : varFormatTime(timeFormat(row?.Start_Time), user?.Time_Format) + (' - ') + varFormatTime(timeFormat(row?.End_Time), user?.Time_Format))}
                                                        </TableCell>

                                                        {/* <TableCell component="th" scope="row">
                                                        {row?.Seniority}
                                                    </TableCell> */}

                                                        <TableCell component="th" scope="row">
                                                            {row?.Hours}
                                                        </TableCell>
                                                        {allowedVars?.V3_SHOW_WEEKLY_OVERTIME_HOUR && (
                                                            <TableCell component="th" scope="row">
                                                                {row?.Weekly_Overtime_Hours}
                                                            </TableCell>
                                                        )}
                                                        <TableCell component="th" scope="row">
                                                            {row?.LogTime ? moment(row.LogTime).format("MM/DD/YYYY, HH:mm") : ""}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" align="right">
                                                            <Row>
                                                                <Col md={6}>
                                                                    <Chip sx={{
                                                                        height: 'auto',
                                                                        color: 'red',
                                                                        '& .MuiChip-label': {
                                                                            display: 'block',
                                                                            whiteSpace: 'normal',
                                                                        },
                                                                    }}
                                                                        style={{ textAlign: 'center', padding: '6px 0px', width: '100%', cursor: 'pointer' }}
                                                                        label='Assign'
                                                                        color="red"
                                                                        onClick={() => {
                                                                            if (row?.Has_Volunteer_Signup === false) {
                                                                                setCurrentRow(row);
                                                                                setActionType("assign");
                                                                                setConfirmModal(true);
                                                                            } else {
                                                                                assignPosition(row);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Col>

                                                                <Col md={6}>
                                                                    <Chip sx={{
                                                                        height: 'auto',
                                                                        color: 'red',
                                                                        '& .MuiChip-label': {
                                                                            display: 'block',
                                                                            whiteSpace: 'normal',
                                                                        },
                                                                    }}
                                                                        style={{ textAlign: 'center', padding: '6px 0px', width: '100%', cursor: 'pointer' }}
                                                                        label='Custom'
                                                                        color="red"
                                                                        onClick={() => {
                                                                            if (row?.Has_Volunteer_Signup === false) {
                                                                                setCurrentRow(row);
                                                                                setActionType("custom");
                                                                                setConfirmModal(true);
                                                                            } else {
                                                                                setAssignEmp(row);
                                                                                setCustomModal(true);
                                                                            }
                                                                        }}


                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </TableCell>

                                                    </TableRow>
                                                ))
                                                    :
                                                    <TableRow>
                                                        <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                                                            No results found
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            }
                        </>)}

                    </Box>
                </Modal.Body>
            </Modal>

            <Modal show={deleteModal} onHide={() => {
                setDeleteModal(false)
                setUnAssignReason('')
            }}>
                <Modal.Header closeButton>
                    <Modal.Title>Unassign Employee</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555', marginLeft: '5px' }}>
                        Are you sure you want to unassign
                        <span style={{ color: '#000000' }}>{" " + unassignEmp?.Employee_Rank + " " + unassignEmp?.Employee_Name} </span>
                        from the shift on
                        <span style={{ color: '#000000' }}>{" " + moment(date).format('MM/DD/YYYY')} {`(${unassignEmp?.Start_Time} - ${unassignEmp?.End_Time})`}?</span>
                    </div>
                    {(v3Data.V3_VOLUNTEER_REQUIRE_UNASSIGN_NOTE || v3Data.V3_VOLUNTEER_REQUIRE_UNASSIGN_NOTE == 'true') &&
                        <Row className="px-3 mt-2">
                            <Col md={12} className="p-0">
                                <label className="mt-2">Reason (Optional)</label>
                                <TextField
                                    className='mt-1 w-100'
                                    multiline
                                    color='secondary'
                                    variant="outlined"
                                    value={unAssignReason}
                                    placeholder="Enter Reason"
                                    sx={{
                                        "& .MuiInputBase-input": {
                                            minHeight: '150px',
                                            maxHeight: '150px',
                                            overflow: 'scroll !important',
                                        }
                                    }}
                                    onChange={(e) => setUnAssignReason(e.target.value)}
                                />
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setDeleteModal(false) }}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={unAssignPosition}>
                                Unassign
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal show={customModal} onHide={() => setCustomModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Custom Time</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                    className="m-0"
                                    key={key}
                                    //   onAccept={(newValue) => selectShift('start_time', newValue)}
                                    onChange={(newValue) => selectShift('start_time', newValue)}
                                    sx={{
                                        "& .MuiOutlinedInput-input": { color: 'black' },
                                        width: "100%",
                                        "& .MuiInputBase-root": {
                                            height: '48px',
                                            fontSize: '14px'
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Col>

                        <Col md={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                    key={key2}
                                    className="m-0"
                                    //   onAccept={(newValue) => selectShift('end_time', newValue)}
                                    onChange={(newValue) => selectShift('end_time', newValue)}
                                    sx={{
                                        "& .MuiOutlinedInput-input": { color: 'black' },
                                        width: "100%",
                                        "& .MuiInputBase-root": {
                                            height: '48px',
                                            fontSize: '14px'
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Col>
                    </Row>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setCustomModal(false)}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => assignPosition('', 'custom')}>
                                Assign
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal show={confirmModal} onHide={() => setConfirmModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Are you sure?</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        {/* This user didn't put signup for this position, Are you  want to assign this user to this position? */}
                        This user hasn’t signed up for this position. Do you still want to assign them to it?
                    </div>

                    <Row className="mt-4">
                        <Col md="auto">
                            <ButtonTheme
                                variant="filled"
                                color="white"
                                onClick={() => setConfirmModal(false)}
                            >
                                Cancel
                            </ButtonTheme>
                        </Col>

                        <Col md="auto">
                            <ButtonTheme
                                variant="filled"
                                color="primary"
                                onClick={() => {
                                    setConfirmModal(false);

                                    if (actionType === "assign") {
                                        assignPosition(currentRow);
                                    }

                                    if (actionType === "custom") {
                                        setAssignEmp(currentRow);
                                        setCustomModal(true);
                                    }
                                }}
                            >
                                Confirm
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            {/* User Modal */}
            <Modal show={assignModalUser} onHide={() => { setAssignModalUser(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Assign Position</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure you want to assign yourself on this position?
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => { assignUserPosition(true) }}>
                                Full Time
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => { setCustomModalUser(true) }}>
                                Custom
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            {/* User Custom */}
            <Modal show={customModalUser} onHide={() => setCustomModalUser(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Custom Time</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                    className="m-0"
                                    key={key}
                                    onChange={(newValue) => selectShift('start_time', newValue)}
                                    sx={{
                                        "& .MuiOutlinedInput-input": { color: 'black' },
                                        width: "100%",
                                        "& .MuiInputBase-root": {
                                            height: '48px',
                                            fontSize: '14px'
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Col>

                        <Col md={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                    key={key2}
                                    className="m-0"
                                    onChange={(newValue) => selectShift('end_time', newValue)}
                                    sx={{
                                        "& .MuiOutlinedInput-input": { color: 'black' },
                                        width: "100%",
                                        "& .MuiInputBase-root": {
                                            height: '48px',
                                            fontSize: '14px'
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Col>
                    </Row>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setCustomModal(false)}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => assignUserPosition(false)}>
                                Assign
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            {/* User Delete */}
            <Modal show={deleteModalUser} onHide={() => { setDeleteModalUser(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Unassign Position</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure you want to unassign yourself from this position?
                    </div>

                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setDeleteModalUser(false) }}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={unAssignUserPosition}>
                                Un-Assign
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            {/* Request Shift Modal */}
            <Modal show={requestShiftUser} onHide={() => { setRequestShiftUser(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Request Shift</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure you want to Request Shift for this position?
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setRequestShiftUser(false) }}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' disabled={posId == ''} onClick={() => { requestShift() }}>
                                Request
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            {/* Revert Request Shift Modal */}
            <Modal show={revertShiftReq} onHide={() => { setRevertShiftReq(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Revert Shift Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure you want to revert the request for this position?
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setRevertShiftReq(false) }}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => { revertReqAssign() }}>
                                Revert
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}